import logo from './logo.svg';
import './App.css';
import Background from './components/Background';
import VerificationForm from './components/VerificationForm';

function App() {
  return (
    <Background
      img={require('../src/assets/background.png')}
    >
      <VerificationForm />
    </Background>
  );
}

export default App;
